import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
// import Testimonials from '../testimonials';
import SplitSliderStory from '../split-slider-story';

// import Video from "../video";
// import FancyTitle from "../fancy-title";

export default function VerticalTestimonials({ blok }) {
  //   const { title, subtitle } = blok.blok;

  const styles = clsx('blok-vertical-testimonials px-4 lg:px-16');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div className="mt-[52px] xl:mt-48">
        <SplitSliderStory
          data={blok.testimonials}
          title={blok.title}
          subtitle="subtitle"
          titlePosition="text-right"
          imageClasses={styles}
        />
      </div>
    </div>
  );
}
